import React from "react";

const Header = () => {
    return (
        <div className="header">
            <h1>Plan Maker</h1>
        </div>
    )
}

export default Header;